import React from 'react';
import { colors } from '../../../constants';

const MarketTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
        return (
            <div
                className="p-1 shadow-sm"
                style={{
                    marginTop: '10px',
                    color: colors.skyfallDark,
                }}
            >
                {payload.map((ele, index) => {
                    return (
                        <div key={index} className="small fw-bold">
                            {ele.payload.week}
                            <br />
                            {ele.payload.count}
                        </div>
                    );
                })}
            </div>
        );
    }
    return null;
};

export default MarketTooltip;
